import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AbstractFieldInterventionEntitiesFilterOptionsComponent } from '@connect-services/client/components/abstract-field-intervention-entities-filter-options/abstract-field-intervention-entities-filter-options.component';
import { OperatorIconComponent } from '@connect-services/client/components/field-intervention-information/field-intervention-operator-or-status-metrics/field-intervention-operator/operator-icon/operator-icon.component';
import { CheckboxComponent } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { Person } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, OperatorIconComponent, RessourcesModule],
    selector: 'app-operators-filter-options',
    styleUrl: 'operators-filter-options.component.scss',
    templateUrl: './operators-filter-options.component.html',
})
export class OperatorsFilterOptionsComponent extends AbstractFieldInterventionEntitiesFilterOptionsComponent {
    protected get sortedOperatorsByCheck(): Person[] {
        return this.sortByCheck<Person>(
            this.filterEntitiesTableService.operatorsWithPagination()?.items ?? [],
            this.filterEntitiesTableService.filterByParams()?.people,
            'id',
        );
    }
}
